import Vue from 'vue'
import Vuex, { GetterTree, MutationTree, Store, ActionTree } from 'vuex'
import assistance from '@/http/assistance'
import * as contest from './contest'
import * as promo from './promo'
import * as freestyle from './freestyle'
import * as bindPhone from './bindPhone'
import * as examples from './examples'
import * as rank from './rank'

Vue.use(Vuex)

export interface Cities {
  province_list: Record<string, string>
  city_list: Record<string, string>
  county_list: Record<string, string>
}

export class ToastError extends Error {}

/**
 * 状态
 */
export interface State {
  /**
   * 挂起
   */
  pending?: boolean
  /**
   * 错误
   */
  error?: Error
  /**
   * 行政区列表
   */
  cities?: Cities
}

export const state: Action<State> = () => ({
  pending: null,
  error: null,
  cities: null
})

export const mutations: MutationTree<State> = {
  begin(state: State) {
    state.pending = true
    state.error = null
  },
  async end(state: State, { error }) {
    state.pending = false
    state.error = error
    if (error) {
      if (error instanceof ToastError) {
        const { Toast } = await import('vant')
        Toast({
          message: error.message,
          duration: 3000
        })
      } else {
        const { Notify } = await import('vant')
        Notify({
          message: error.message,
          duration: 3000
        })
      }
    }
  },
  endGetCities(state: State, { cities }) {
    state.cities = cities
  }
}

export const getters: GetterTree<State, State> = {
  /**
   * 挂起
   */
  pending: state => state.pending,
  /**
   * 错误
   */
  error: state => state.error,
  /**
   * 行政区列表
   */
  cities: state => state.cities
}

export const actions: ActionTree<State, State> = {
  /**
   * 获取城市列表
   */
  async getCities({ commit }) {
    let cities: any
    let error: Error
    commit('begin')
    try {
      cities = await assistance.get('/Common/getVantAreaList')
    } catch (err) {
      error = err
    }
    commit('end', { error })
    if (error) {
      throw error
    }
    commit('endGetCities', { cities })
  }
}

export default new Store({
  state,
  mutations,
  getters,
  actions,
  modules: {
    contest,
    promo,
    freestyle,
    bindPhone,
    examples,
    rank
  }
})
